export const generativeAiAgentsUniqueName = "/generative_ai/agents/unique_name";
